import { createStore, applyMiddleware,combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';
import { createBrowserHistory,History } from 'history';
//import { routerMiddleware } from 'react-router-redux';
import dictionary from './redux/DictionaryRedux';
import AuthRedux from './redux/AuthRedux';
const createRootReducer = (his: History) =>
    combineReducers({
      toastr,
      dictionary,
      AuthRedux
    });


const history = createBrowserHistory();

const rootReducer = createRootReducer(history);



const store = createStore(
  rootReducer,
  undefined,
//  applyMiddleware(thunk, routerMiddleware(history)),
);

export { history };
export default store;
